import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, MESSAGES } from "@/constants/site";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#0A0A0B]/75 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
      <a href="#inicio" onClick={scrollTo("inicio")} data-testid="header-logo" aria-label="Salão Estrela — início">
        <Logo />
      </a>
      <nav className="hidden items-center gap-10 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#A1A09E] lg:flex">
        <a href="#inicio" onClick={scrollTo("inicio")} className="transition-colors duration-300 hover:text-[#F9F8F6]">Início</a>
        <a href="#produtos" onClick={scrollTo("produtos")} className="transition-colors duration-300 hover:text-[#F9F8F6]">Produtos</a>
        <a href="#transformacoes" onClick={scrollTo("transformacoes")} className="transition-colors duration-300 hover:text-[#F9F8F6]">Antes e Depois</a>
        <a href="#contato" onClick={scrollTo("contato")} className="transition-colors duration-300 hover:text-[#F9F8F6]">Contato</a>
      </nav>
      <a
        href={waLink(MESSAGES.header)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-whatsapp-button"
        className="group flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#F9F8F6] transition-all duration-300 hover:border-[#D4AF37] hover:bg-[#0A0A0B] hover:text-[#F9F8F6]"
      >
        <WhatsAppIcon className="h-4 w-4" />
        <span className="hidden sm:inline">Fale Conosco</span>
        <span className="sm:hidden">Contato</span>
      </a>
    </div>
  </motion.header>
);
